import { render } from "./contactSection.vue?vue&type=template&id=88425ce6&scoped=true"
import script from "./contactSection.vue?vue&type=script&lang=js"
export * from "./contactSection.vue?vue&type=script&lang=js"

import "./contactSection.vue?vue&type=style&index=0&id=88425ce6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88425ce6"]])

export default __exports__